import { render, staticRenderFns } from "./EditPPage.vue?vue&type=template&id=2dffeaf6&"
import script from "./EditPPage.vue?vue&type=script&lang=js&"
export * from "./EditPPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports